/**
 * Cliente de cache, num módulo próprio.
 *
 * ── Por que não fica no main.tsx ────────────────────────────────────────────
 *
 * O cache precisa ser **descartado sempre que a identidade muda**. Sem isso,
 * quem faz logout e entra com outra conta no mesmo navegador vê, por alguns
 * instantes, os dados de quem estava antes — grupos, financeiro, lista de
 * participantes. O servidor responde certo; é a memória do cliente que está
 * suja, e para o usuário isso é indistinguível de um vazamento.
 *
 * Deixar a instância aqui permite que o store de autenticação a limpe em toda
 * transição, em vez de depender de alguém lembrar disso em cada tela.
 */

import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      // 4xx não se resolve repetindo; falha de rede e 5xx, sim.
      retry: (count, error) =>
        error instanceof ApiError && !error.isTransient ? false : count < 2,
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
});

/**
 * Descarta tudo que estava em memória.
 *
 * `clear()` e não `invalidateQueries()`: invalidar marca como obsoleto mas
 * mantém o dado antigo visível enquanto revalida — exatamente o comportamento
 * que causaria o vazamento entre contas.
 */
export function resetQueryCache(): void {
  queryClient.clear();
}
